import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=5bbaadd0&scoped=true&"
import script from "./Multiselect.vue?vue&type=script&lang=js&"
export * from "./Multiselect.vue?vue&type=script&lang=js&"
import style0 from "./Multiselect.vue?vue&type=style&index=0&id=5bbaadd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbaadd0",
  null
  
)

export default component.exports